import { homApi } from '~/redux/apis/hom'

import { MathTopicData } from '~/MathTopics/types/math-topic.type'

export const mathTopicApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    getMathTopicsData: builder.query<MathTopicData, { language: string }>({
      query: (params) => ({
        url: '/v1/math-topics',
        method: 'GET',
        params,
      }),
    }),
  }),
})

export const {
  useGetMathTopicsDataQuery,
  util: { getRunningQueriesThunk },
} = mathTopicApi

export const { getMathTopicsData } = mathTopicApi.endpoints
